function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-35.4,428.2c4-10.4,6.4-20.8,6.4-31.2s-2.4-20.8-6.4-31.2c-4-9.6-9.6-18.4-16.8-25.6c-7.2-7.2-16-12.8-25.6-16.8 s-20-6.4-31.2-6.4s-21.6,2.4-31.2,6.4c-9.6,4-18.4,9.6-25.6,16.8c-7.2,7.2-12.8,16-16.8,25.6c-4,10.4-6.4,20.8-6.4,31.2 c0,11.2,2.4,21.6,6.4,31.2c4,9.6,9.6,18.4,16.8,25.6c7.2,7.2,16,12.8,25.6,16.8s20,6.4,31.2,6.4s21.6-2.4,31.2-6.4 c9.6-4,18.4-9.6,25.6-16.8C-45,446.6-39.4,437.8-35.4,428.2z M-44.2,369.8c4,8.8,5.6,17.6,5.6,27.2c0,9.6-1.6,18.4-5.6,27.2 s-8.8,16-15.2,22.4s-13.6,11.2-22.4,15.2c-8.8,4-17.6,5.6-27.2,5.6c-9.6,0-18.4-1.6-27.2-5.6s-16-8.8-22.4-15.2 s-11.2-13.6-15.2-22.4c-4-8.8-5.6-17.6-5.6-27.2c0-9.6,1.6-18.4,5.6-27.2s8.8-16,15.2-22.4s13.6-11.2,22.4-15.2 c8.8-4,17.6-5.6,27.2-5.6c9.6,0,18.4,1.6,27.2,5.6s16,8.8,22.4,15.2C-53.8,353.8-48.2,361-44.2,369.8z"
});

var SvgSwrpgForceOutline = function SvgSwrpgForceOutline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgForceOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-force-outline.6ea6b836.svg";
export { ForwardRef as ReactComponent };